<template>
<div>
  <div class="head" @click="btn">
    <div class="headIcon"></div>
    <div class="headTitle">嗨科普</div>
    <div class="headOpen">打开</div>
  </div>
</div>
</template>

<script>
import {baseConfig} from "../../../network/baseConfig";

export default {
  name: "shareHead",
  methods:{
    btn(){
      console.log('foot open app')
      // this.$emit("openApp",null)
      console.log('打开APP')
      window.location.href = baseConfig.getAppInfo().href
    }
  }
}
</script>

<style scoped>
.head{
  position: fixed;
  top: 0px;
  height: 130px;
  width: 100%;
  /*background-color: #fee9e4;*/
  background-color: white;
  z-index: 21;
  border-bottom: 1px solid #f3f3f3;
}
.headIcon{
  float: left;
  margin-left: 45px;
  width: 60px;
  height: 100%;
  background-image: url("../../../assets/app/logo.png");
  background-size: 50px 51px;
  /*background-color: #790e0e;*/
  background-repeat: no-repeat;
  background-position: center center;
}
.headTitle{
  float: left;
  height: 80px;
  margin-top: 25px;
  margin-left: 25px;
  font-size: 46px;
  font-weight: bolder;
  line-height: 80px;
  letter-spacing: 0.08em;
  color: #406eb9;
}
.headOpen{
  float: right;
  margin-top: 35px;
  margin-right: 60px;
  margin-left: 45px;
  font-size: 35px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  background-color: #fe2300;
  color: white;
  padding-right: 40px;
  padding-left: 40px;
  font-weight: bolder;
  letter-spacing: 0.2em;
}

</style>